import { ICountry, IService } from 'dataSources/Typicode/common/types';
import { IDirectory } from 'common/types/common/directory';
import { MapName } from 'common/utils';

import { TI18n } from './i18n';
import { TIsLoading } from './isLoading';
import { INotice } from './notice';

export const STATE = 'APPLICATION';

export interface IState {
  i18n: TI18n;
  isLoading: TIsLoading;
  countries: ICountry[];
  roadsideService: IDirectory[];
  stationCategories: IDirectory[];
  serviceFormats: IDirectory[];
  additionalParams: IDirectory[];
  additionalServices: IDirectory[];
  services: IService[];
  notice: null | INotice[];
  activeMap?: MapName;
}
